import { heroCards, siteMeta, tickerItems } from '@/mocks/homeData';

function Ticker() {
  const items = [...tickerItems, ...tickerItems];
  return (
    <div className="mt-20 md:mt-[88px] bg-foreground-950 text-background-50">
      <div className="mx-auto flex max-w-7xl items-center px-4 md:px-6">
        <div className="flex shrink-0 items-center gap-1.5 bg-primary-500 px-3 py-2 text-[13px] font-semibold text-background-50">
          <i className="ri-time-line"></i>
          <span className="whitespace-nowrap">实时速递</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-[ticker_28s_linear_infinite] gap-10 py-2 pl-6">
            {items.map((t, i) => (
              <span key={i} className="flex items-center gap-2 text-[13px] text-background-100 whitespace-nowrap">
                <i className="ri-capsule-fill text-accent-400 text-[10px]"></i>
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
      <style>{`@keyframes ticker { from { transform: translateX(0);} to { transform: translateX(-50%);} }`}</style>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="top" className="newsprint-grid">
      <Ticker />
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-10">
        {/* 首屏标题条 */}
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-sparkling-2-fill"></i>
              {siteMeta.slogan}
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950 text-balance">
              今日<b className="text-primary-600">重磅</b> 多卡速览
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-500">
              图文到视频一网打尽，热点按图索骥，一次看个够。下方四张主力卡覆盖今日最热瓜田。
            </p>
          </div>
          <a
            href="#flash"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            看更多
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* 首屏多卡并列 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {heroCards.map((c, idx) => (
            <a
              key={idx}
              href="#flash"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
            >
              <div className="relative h-52 md:h-56 overflow-hidden bg-background-100">
                <img
                  src={c.img}
                  alt={c.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent"></div>
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/95 px-2.5 py-1 text-xs font-semibold text-foreground-900">
                  <i className={`${idx === 0 ? 'ri-fire-fill text-primary-500' : 'ri-flashlight-fill text-accent-600'} text-[11px]`}></i>
                  {c.tag}
                </span>
                <span className="absolute right-3 top-3 inline-flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-background-50">
                  {c.hot}
                </span>
                <span className="absolute bottom-3 left-3 text-xs text-background-100/90">{c.meta}</span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 font-heading text-[15px] font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                  {c.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-[13px] leading-relaxed text-foreground-500">{c.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                  点我按图索骥 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}